<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div 
    class="card"
  >
    <br>
    <!--If Cart is Empty-->
    <v-container
      v-if="cartTotals.countTotal===0"
      class="flex flex-col gap-3"
    > 
      <h1>
        Your Cart is Empty
      </h1>
      <p>
        Have a product idea or request? <br> We want to hear it.
      </p>
      <NuxtLink to="/contact">
        <p class="link link-secondary">
          Contact Us
        </p>
      </NuxtLink>
      <br>
      <!-- btn btn-lg btn-primary text-xl  text-secondary-content drop-shadow-lg -->
      <NuxtLink to="/">
        <button
          class="butter"
        >
          Go Shopping <br> Find Something You Love
        </button>
      </NuxtLink>
    </v-container>


    <div class="grid grid-cols-1 md:grid-cols-3">
      <!-- Order Summary -->
      <div
        v-if="cartTotals.countTotal>0"
        class="col-span-1 h-full"
      >
        <h1>
          Order Summary
        </h1>
        <p>
          Items in Cart: {{ cartTotals.countTotal }}
        </p>
        <p>Item Cost: {{ formatter.format(Math.ceil(cartTotals.itemTotal)/100) }}</p>
        <p>Shipping Cost: {{ formatter.format(Math.ceil(cartTotals.shipTotal)/100) }}</p>
        <p class="font-bold text-secondary text-lg mt-1">
          Total {{ formatter.format((cartTotals.grandTotal)/100) }}
        </p>
        <button
          v-if="showCartItems"
          class="btn btn-primary mb-4 mt-4"
          @click="checkout() "
        >
          Continue to Checkout
        </button>
        <br>
        
        <br>
      </div>
      
      <div
        v-if="!infoSubmitted && cartTotals.countTotal>0"
        class="grid col-span-2 ml-5"
      >
        <!--Items in Cart-->
        <div
          v-if="showCartItems"
          class="grid grid-cols-3 gap-2"
        >
          <div class="col-span-3 my-2">
            <div
              v-for="(item, idx) in useUserDataStore().userData.cart"
              :key="idx"
              class="grid grid-cols-3"
            >
              <!-- C1 -->
              <div class="col-span-3 sm:col-span-1 my-2">
                <NuxtLink :to="'/shop/product/'+item.productId">
                  <div class="w-full h-full">
                    <NuxtImg :src="item.photoURL" />
                  </div>
                </NuxtLink>
              </div>

              <!-- C2 -->
              <div class="sm:col-span-2 col-span-3 relative text-wrap text-left flex flex-col justify-center ml-5">
                <button
                  class="btn-circle btn-outline btn bg-base-200 z-2 absolute right-0 top-0"
                  @click="removeItem(item)"
                >
                  X
                </button><NuxtLink :to="'/shop/product/'+item.productId">
                  <p
                    class="text-xl font-bold mr-12"
                  >
                    {{ item.productTitle }}
                  </p>
                  <p>
                    {{ item.variantTitle }}
                  </p>
                </NuxtLink>
                <br>
                <p><span class="">Item:</span> {{ formatter.format((Math.ceil(item.price * item.quantity))/100) }}</p>
                <!-- MAJOR TODO -->
                <!-- // fetch shipping rates based on user shipping address and let users select their desired shipping options for each item
                // we might actually need to group lineitems by fulfillers so we can bundle shipments for each unique fulfiller
                // after a user selects their chosen rates, we need to process the array of rates in the payment-success webhook endpoint -->
                <p v-if="item.shipCost">
                  <span class="">Shipping:</span> {{ formatter.format((Math.ceil(item.shipCost*item.quantity))/100) }}
                </p>
                <!--v-if="item.shippingOptions" an option dropdown will go here to allow users to select a shipping rate-->
                <!-- <p class="font-bold">
                Total: {{ formatter.format((Math.ceil((item.price + item.shipCost) * item.quantity))/100) }}
              </p> -->
                <br>
                <div class="flex">
                  <button
                    class="text-center"
                    @click="decreaseCartItemQty(item)"
                  >
                    -
                  </button>
                  <p class="text-center mx-6">
                    {{ item.quantity }}
                  </p>
                  <button
                    class="text-center"
                    @click="item.quantity++"
                  >
                    +
                  </button>
                </div>
              </div>
              <div 
                v-if="idx!=useUserDataStore().userData.cart.length-1"
                :class="idx==useUserDataStore().userData.cart.length-1?'':'divider'"
              />
            </div>
          </div>
        </div>

        <button
          v-if="showCartItems && cartTotals.countTotal>=3"
          class="btn btn-primary mx-auto mt-8"
          @click="checkout() "
        >
          Continue to Checkout
        </button>
        <div v-if="showForceUserLogin && !useCurrentUser().value">
          <h1>You are not currently logged in.</h1>
          <p>Please login if you wish to preserve your order history.</p>
          <br>
          <div class="flex flex-col flex-wrap gap-4 justify-center align-center">
            <button
              class="btn btn-wide btn-secondary text-secondary-content"
              @click="newAccountPopup=true"
            >
              Create Account
            </button>
            <button
              class="btn btn-wide btn-secondary text-secondary-content"
              @click="useRouter().push('/login')"
            >
              Login With Existing Account
            </button>
            <button
              class="btn btn-wide btn-secondary text-secondary-content"
              @click="loginWithGoogle()"
            >
              Login With Google
            </button>
          </div>
          <br>
          <ClientOnly>
            <p
              class="link link-primary"
              @click="submitAnonymously()"
            >
              Continue without creating an account.
            </p>
          </ClientOnly>
          <br>
        </div>
        <div
          v-if="!showCartItems"
        >
          <div
            v-if="useCurrentUser().value && !infoSubmitted" 
            class="col-span-2"
          >
            <ShippingProfiles>
              <template #title>
                <h1>Shipping Address</h1>
              </template>
            </ShippingProfiles>  
            <!--Terms-->
            <div class="form-control mt-2">
              <label class="cursor-pointer label">
                <input
                  v-model="terms"
                  type="checkbox"
                  class="checkbox bg-base-100 outline checkbox-md"
                >
                <span class="w-full ml-4 text-left">
                  <p class="">
                    I agree to all
                    <a
                      class="link link-acccent"
                      :href="'https://'+useRuntimeConfig().public.SITE_DOMAIN+'/legal/termsAndConditions'"
                      target="_blank"
                    >
                      Terms, Conditions, and Policies</a>
                  </p>
                </span>
              </label>
            </div>
            <br>
            <!--Place Order Button-->
            <button
              v-if="terms && find(useUserDataStore().userData.shippingInfo, useUserDataStore().userData.selectedShippingInfo)!==undefined"
              class="btn btn-primary"
              @click="submitInfo()"
            >
              Place Order
            </button>
            <button
              v-else
              class="btn btn-disabled btn-primary text-primary-content"
            >
              Place Order
            </button>
          </div>
        </div>       
      </div>

      <!--PAYMENT ELEMENT MUST NEVER BE WITHIN A V-IF/CONDITIONAL-->
      <div :class="infoSubmitted ?'grid col-span-2 ml-5':'invisible'">
        <!--mt-[-50px]-->
        <div
          id="payment-form"
          @submit.prevent="handleSubmit"
        >
          <h1>
            Place Order
          </h1>
          <!-- New Saved Payment Methods Thing (Needs Frontend Help) -->
          <div v-if="paymentMethods && !paymentMethods.error && paymentMethods.length>0">
            <li
              v-for="(card,idx) in paymentMethods"
              :key="idx"
            >
              {{ card }}
            </li>
          </div>
          <div
            id="payment-element"
            class="p-5 pt-0"
          />
          <!--Payment Element Buttons-->
          <div class="flex justify-space-around pb-2 gap-5">
            <!--Cancel Button-->
            <button
              v-if="infoSubmitted"
              id="cancel"
              :disabled="isLoading"
              class="btn flex-grow btn-primary text-primary-content"
              @click="cancelIntent"
            >
              Cancel
            </button>
            <!--Submit Button-->
            <button
              v-if="infoSubmitted"
              id="submit"
              :disabled="isLoading"
              class="btn flex-grow btn-primary text-primary-content"
              @click="submitButton"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
   
    <PopUp v-if="newAccountPopup">
      <template #popuptitle>
        Create An Account
      </template>
      <template #exitbtn> 
        <button
          class="w-full h-full"
          @click="newAccountPopup=false"
        >
          X
        </button>
      </template>
      <v-form
        ref="isValid"
        @submit.prevent="submitNewAccount"
      >
        <div class="twocolinputs">
          <v-text-field 
            v-model="newFirstName"
            type="text"
            label="First Name"
          />
          <v-text-field 
            v-model="newLastName"
            type="text"
            label="Last Name"
          />
          <v-text-field 
            v-model="newDisplayName"
            type="text"
            label="Display Name"
            :rules="[rules.required, rules.username]"
          />
          <v-text-field 
            v-model="newEmail"
            type="text"
            label="Email"
            :rules="[rules.required, rules.email]"
          />
          <!-- <v-text-field
          v-model="phoneNumber"
          type="text"
          label="Phone"
          :rules="[rules.phone]"
        /> -->
          <v-text-field 
            id="password"
            v-model="newPassword"
            :rules="[rules.required, rules.min, rules.password]"
            type="password"
            label="Password"
          />
          <v-text-field 
            id="confirmPassword"
            v-model="confirmPassword"
            :rules="[rules.required, rules.password, rules.min, rules.match]"
            type="password"
            label="Confirm Password"
          />
        </div>
        <v-checkbox
          v-model="terms"
          class="text-left mb-n2 w-full"
          label="I agree with the Terms and Conditions."
        /> 
        <div class="vbtn btn-secondary text-secondary-content w-full">
          <v-btn
            v-if="!terms"
            class="btn-disabled btn-secondary text-secondary-content"
            variant="text"
            disabled
          >
            Submit
          </v-btn>
          <v-btn
            v-if="terms"
            type="submit"
            variant="text"
            @click="submitNewAccount"
          >
            Submit
          </v-btn>
        </div>
      </v-form>
      <p
        v-if="!useCurrentUser()"
        class="text-secondary mt-4"
      >
        Your order history will not be saved without an account.
      </p>
    </PopUp>
    <!--BEHelp: Make snackbar show then disappear when someone tries to make a new account with an existing email.-->
    <div 
      v-if="existingEmailSnackbar" 
      class="snackbar elevation-10"
    >
      <span>This email is associated with an existing account.</span>
    </div>
    <!--Loader-->
    <v-dialog
      v-model="showLoader"
      width="auto"
    >
      <LazyLoader />
    </v-dialog>
    <!-- </v-container> -->

    <!--Payment Failure Dialog-->
    <v-dialog
      v-model="popupVisible"
      style="max-width: 800px; margin-bottom: 8px; padding: 5px;"
    >
      <v-card>
        <div
          class="text-center"
          style="max-width: 800px; margin-bottom: 8px; padding: 5px;"
        >
          <h2 class="text-2xl font-bold">
            Payment Error
          </h2>
          <br>
          <p>{{ popupMsg }}</p>
          <br>
          <v-card-actions>
            <v-btn
              color="primary"
              block
              @click="popupVisible = false"
            >
              Close Dialog
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </div>
  <!-- </div> -->
  <!-- <ShopFooter /> -->
</template>


<script setup>
import { useCurrentUser, useFirestore, useFirebaseApp } from 'vuefire'
import { signInAnonymously, GoogleAuthProvider, signInWithPopup, getAuth, createUserWithEmailAndPassword, updateProfile, sendEmailVerification } from 'firebase/auth';
import { useUserDataStore } from '~/stores/userData'
import { addDoc, collection, doc, setDoc, runTransaction } from 'firebase/firestore';
import { filter, find, isEqual } from 'lodash-es'
import { loadStripe } from '@stripe/stripe-js';
// import dropin from 'braintree-web-drop-in';

var elements
var stripe

const selectedShipping = ref({})

const newAccountPopup = ref(false)
const existingEmailSnackbar = ref(false)

onMounted(async()=>{
  stripe = await loadStripe(useRuntimeConfig().public.STRIPE_PUBLIC_KEY)
  selectedShipping.value = useUserDataStore().userData.selectedShippingInfo
})

const userInfo = ref()
const firebaseOrderId = ref()
// const password = ref('')
const cartTotals = ref({countTotal:0,itemTotal:0,shipTotal:0,grandTotal:0})
const popupVisible = ref(false)
const popupMsg = ref('Well this is unfortunate...')

const infoSubmitted = ref(false)
const terms = ref(false)
const showCartItems = ref(true)
// const contwithout = ref(false)

const paymentElement = ref()
const isLoading = ref()

const formatter = new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'})

const isValid = ref()
const newFirstName = ref('')
const newLastName = ref('')
const newDisplayName = ref('')
const phoneNumber = ref('')
const newPassword = ref('')
const confirmPassword = ref('')
const newEmail = ref('')

const passPattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/
const emailPattern = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
const phonePattern = /^^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/

const rules = ref({
  email: v=> emailPattern.test(v) || 'Invalid E-mail',
  required: value => !!value || 'Required.',
  min: v => v.length >= 8 || 'Min 8 characters',
  phone: v=>phonePattern.test(v) || 'Invalid Phone Number',
  password: v=> passPattern.test(v) || 'Must Contain 8 Characters, Lowercase, Uppercase, and A Number',
  match: v=> v===newPassword.value || "Passwords Don't Match",
  username: v=>v.length>0 || 'Invalid Username'
})

watch(useUserDataStore().userData,(userStore)=>{
  userInfo.value = userStore.userInfo
  selectedShipping.value = userStore.selectedShippingInfo //A shipping address must be selected in order to fetch shipping rates for custom fulfilled products


  cartTotals.value.itemTotal=0
  cartTotals.value.shipTotal=0 //A shipping address must be selected in order to fetch shipping rates for custom fulfilled products
  cartTotals.value.grandTotal=0
  cartTotals.value.countTotal=0
  for(let i=0; i<userStore.cart.length;i++){
    cartTotals.value.itemTotal+=Math.ceil(userStore.cart[i].price * userStore.cart[i].quantity)
    cartTotals.value.shipTotal+=Math.ceil(userStore.cart[i].shipCost * userStore.cart[i].quantity) //A shipping address must be selected in order to fetch shipping rates for custom fulfilled products
    cartTotals.value.countTotal+=userStore.cart[i].quantity
  }
  cartTotals.value.grandTotal=Math.ceil(cartTotals.value.itemTotal + cartTotals.value.shipTotal)
}, {immediate:true})

const decreaseCartItemQty = (item) => {
  item.quantity--
  if(item.quantity==0){
    removeItem(item)
  }
  // useUserDataStore().userData.cart = filter(useUserDataStore().userData.cart,(p)=>{return p.quantity>0})
}

// const increaseCartItemQty = (item) => {
//   item.quantity++
// }

const removeItem = (item) =>{
  // item.quantity=0
  //Looping down through the array so we can splice without affecting stuff
  for(let i=useUserDataStore().userData.cart.length-1; i>-1; i--){
    let cartItem = useUserDataStore().userData.cart[i]
    if(cartItem.productId==item.productId && cartItem.variantId==item.variantId){
      useUserDataStore().userData.cart.splice(i,1)
    }
  }
  //Old
  // useUserDataStore().userData.cart.forEach((i,idx)=>{
  //   if(i.productId==item.productId&&i.variantId==item.variantId){//should this be == or ===?
  //     useUserDataStore().userData.cart[idx].quantity=0
  //     useUserDataStore().userData.cart.splice(idx, 1)
  //   }
  // })
  // // overkill
  // useUserDataStore().userData.cart = filter(useUserDataStore().userData.cart,(p)=>{return p.quantity>0})
}

const loginWithGoogle = () => {
  const provider = new GoogleAuthProvider()
  // provider.addScope('https://www.googleapis.com/auth/contacts.readonly');
  // Need to determine what Google scopes to add.
  // Calendar, sheets, drive, docs, etc.

  //May need to use firebase/auth getAuth
  signInWithPopup(getAuth(useFirebaseApp()),provider).then(async(result)=>{
    getAuth(useFirebaseApp()).currentUser = result.user
    
    //Transaction
    const userDocRef = doc(useFirestore(),'users', result.user.uid)
    try{
      await runTransaction(useFirestore(),async(transaction)=>{
        const userDoc = await transaction.get(userDocRef)
        let aCart = useUserDataStore().userData.cart
        let oCart = userDoc.get('cart')

        if(userDoc.exists()){
          //update it with any info, then merge the cart
          useUserDataStore().userData.userInfo = userDoc.get('userInfo')
          useUserDataStore().userData.theme = userDoc.get('theme')
          useUserDataStore().userData.selectedShippingInfo = userDoc.get('selectedShippingInfo')
          useUserDataStore().userData.shippingInfo = userDoc.get('shippingInfo')
          useUserDataStore().userData.wishes = userDoc.get('wishes')
          useUserDataStore().userData.orders = userDoc.get('orders')
          if(!isEqual(aCart, oCart)){
            // const newCart = union(oCart,aCart)
            // Going to use a better custom merge instead
            // Should ADD unlogged items to the users stored cart items
            // Should UPDATE items already in the users stored cart if updated in local store
            //Here is where we should decide whether or not to showCartItems again
            showCartItems.value = true
            useUserDataStore().userData.cart = aCart.filter(aa => !oCart.find(bb => aa["productId"] === bb["productId"] && aa["variantId"] === bb["variantId"])).concat(oCart);
            transaction.update(userDocRef,{cart:useUserDataStore().userData.cart})
          }

          //Any other things we need to set from transaction data?

          // useUserDataStore().userData = userDoc.data()
        }else{
          const stripeCustomerId = await $fetch('/api/payment/stripe/customer',{method:'POST',headers:{token:await result.user.getIdToken()}})
          useUserDataStore().userData.userInfo = {
            email: result.user.email,
            phone: result.user.phoneNumber,
            uid: result.user.uid,
            verified: result.user.emailVerified,
            displayName: result.user.displayName==null?result.user.email:result.user.displayName, //could be nice to utilize useUserDataStore().userData.selectedShippingInfo.firstName
            anon: result.user.isAnonymous,
            stripeCustomerId: stripeCustomerId
          }
          try{
            transaction.set(userDocRef,useUserDataStore().userData,{merge:true})
          }catch(e){
            console.log(e)
          }
        }
      }).then(async()=>{
        console.log("Hooray you logged in.")
      })
    }catch(e){
      //Need to notify the user that there was a problem
      console.error(e)
    }
  })
}

const showForceUserLogin = ref(false)
const checkout = () =>{
  if(useUserDataStore().userData.cart.length===0){
    return {error:"Cart is empty"}
  }
  showCartItems.value=!showCartItems.value

  if(!useCurrentUser().value){
    showForceUserLogin.value = true
  }
  
}
const showLoader = ref(false)

const submitAnonymously = () => {
  //sign in anonymously
  //after the order is placed (and in a future email perhaps?) anonymous users may upgrade to permanent users
  // const auth = getAuth(useFirebaseApp())
  signInAnonymously(getAuth()).then(async(user)=>{
    //in app.vue we should figure out how anon signins affect onAuthStateChanged calls
    //We should also set userInfo.anon=true
    const stripeCustomerId = await $fetch('/api/payment/stripe/customer',{method:'POST',headers:{token:(await useCurrentUser().value.getIdToken())}})

    userInfo.value.uid = user.user.uid
    userInfo.value.anon = true
    userInfo.value.stripeCustomerId = stripeCustomerId
    //ensure local datastore reflects userInfo ref
    useUserDataStore().userData.userInfo = userInfo.value

    //set userdoc
    await setDoc(doc(useFirestore(),'users',user.user.uid),useUserDataStore().userData,{merge:true})
    
    
    //Now what should I toggle to show?
    newAccountPopup.value = false
  })
}

const paymentMethods = ref([])

const submitInfo = async () => {
  // console.log(useUserDataStore().userData.selectedShippingInfo)
  showLoader.value = true

  //Currently broken if no payment methods are stored in vault, doesn't know what to return
  //let's call to our server and see if the user has any stored payment methods :)
  try{
    paymentMethods.value = await $fetch('/api/payment/stripe/vault',{headers:{token:(await useCurrentUser().value.getIdToken())}})
    if(paymentMethods.value.error){
      throw paymentMethods.value.error
    }
  }catch(e){
    console.log(e)
  }
  //CREATE OUR PENDING ORDER (in Firebase)
  // let lineItems = []
  let itemTotal=0
  let shipTotal=0
  let firebaseLineItems = [] //This array of objects, for each variant in cart, {product_id, variant_id, quantity}
  for (let i=0; i<useUserDataStore().userData.cart.length;i++) {
    firebaseLineItems.push({
      id:useUserDataStore().userData.cart[i].productId,
      productTitle: useUserDataStore().userData.cart[i].productTitle,
      variantId: useUserDataStore().userData.cart[i].variantId,
      variantTitle: useUserDataStore().userData.cart[i].variantTitle,
      photoUrl: useUserDataStore().userData.cart[i].photoURL,
      quantity: useUserDataStore().userData.cart[i].quantity,
      price: useUserDataStore().userData.cart[i].price, //we should probably actually not pull this from the cart - actually it's okay here, server will take care of you
      shipCost: useUserDataStore().userData.cart[i].shipCost, //we should probably actually not pull this from the cart - same as above, this should be ok
      sku: useUserDataStore().userData.cart[i].sku
    })
    itemTotal+=useUserDataStore().userData.cart[i].price
    shipTotal+=useUserDataStore().userData.cart[i].shipCost
  }

  const firebaseOrder = {
    status: 'Pending Payment',
    statusLog:[{author:useRuntimeConfig().public.SHOP_NAME,displayName:useRuntimeConfig().public.SHOP_NAME,msg:'Pending Payment',date:new Date()}],
    paymentStatus: 'Not Paid',
    // printifyOrderStatus: 'Not Sent',
    // printifyOrderId: '',
    userInfo: {
      uid:useCurrentUser().value.uid,
      anon:useCurrentUser().value.isAnonymous,
      stripeCustomerId:useUserDataStore().userData.userInfo.stripeCustomerId
    },// USED TO USE, NOW WE NEED TO BE SPECIFIC useUserDataStore().userData.userInfo,
    shipments:[],
    shippingInfo: useUserDataStore().userData.selectedShippingInfo,
    date: new Date(),
    lineItems: firebaseLineItems,
    shipDate: 'Unshipped',
    etaDate: 'Unprocessed',
    deliveryDate: 'Unknown',
    shippedItems:0,
    itemTotal:itemTotal,
    shipTotal:shipTotal,

    //Don't need to make the case stuff unless a case is created.... case field is OPTIONAL
    //Need to make special rules in firestore to ensure customers can only read and create the cases.publicLog, and update only the specific items in the publicLog array with a uid matching author
    // case:{
    //   isActive:false,
    //   assignee:'Unassigned',
    //   caseType:'',
    //   status:'',
    //   log:[/*{date:new Date(), msg:'Example',author:useCurrentUser().value.uid,?authorPhotoUrl:'http://url.com/img',authorName:useCurrentUser().value.displayName, ?uploads:[/* I really don't know how to do this yet*]}*/],
    //   // privateLog:[/*{date:new Date(), msg:'Example',author:useCurrentUser().value.uid,?authorPhotoUrl:'http://url.com/img',authorName:useCurrentUser().value.displayName, ?uploads:[/* I really don't know how to do this yet*]}*/]
    // }
  }
  if(!useCurrentUser().value.isAnonymous){
    firebaseOrder.userInfo.displayName = useCurrentUser().value.displayName
    firebaseOrder.userInfo.email = useCurrentUser().value.email
    if(useCurrentUser().value.phone && useCurrentUser().value.phone.length>9){
      firebaseOrder.userInfo.phone = useCurrentUser().value.phone
    }
  }

  //Let's push our new pending order to firebase :D
  const firebasePost = await addDoc(collection(useFirestore(),"orders"),firebaseOrder)

  firebaseOrder.id = firebasePost.id
  // New Way - Push the whole docRef
  useUserDataStore().userData.orders.push(firebaseOrder)
  // Old Way
  // useUserDataStore().userData.orders.push({id:firebasePost.id,created_at:firebaseOrder.date,status:firebaseOrder.status})

  firebaseOrderId.value = firebasePost.id //old method: firebasePost._key.path.segments[1] // but idk wtf i was thinking with that old shit code //... but it worked....


  //We need to run the paymentElement.mount from within onMounted
  //...but we can't get our paymentIntent until users are completely ready to submit their cart
  //So here is where we are going to re-route users to a new page where the payment intent is created onMounted based on the orderInfo that we lookup from firestore.
  
  //Next, we should use the client secret to initialize stripe elements and build the checkout
  //might have to update the payment intent with a payment method id later??
  // paymentMethods = await stripe.paymentMethods.list({
  //   customer: useUserDataStore().userData.userInfo.stripeCustomerId,
  //   type: 'card',
  // });

  //First we should actually check for stored payment methods using the backend
  // https://stripe.com/docs/api/payment_methods/list

  //Then, if there are options, we should display these as well as the 'Save New Payment Method' Button

  //Finally we should add the payment method to the payment_intent if one is selected (or just run the payment if new payment is added)

  const clientSecret = await $fetch('/api/payment/stripe/intent', {method:'POST',body:{cart:firebaseLineItems, orderId:firebasePost.id},headers:{token:(await useCurrentUser().value.getIdToken())}})
  console.log("Hell yeah, payment intent client secret: " + clientSecret)

  elements = stripe.elements({clientSecret:clientSecret});

  paymentElement.value = elements.create('payment')
  paymentElement.value.mount('#payment-element')
  isLoading.value = false
  showLoader.value = false
  // const stripe = loadStripe(useRuntimeConfig().STRIPE_PUBLIC_KEY)
  // elements = stripe.elements({
  //   clientSecret: String(clientSecret)
  // })
  // isLoading.value = false  


  //Let's update our user's shippingInfo and billingInfo fields if needed
  const userDocRef = doc(useFirestore(),'users',useCurrentUser().value.uid)

  setDoc(userDocRef, {
    'shippingInfo': useUserDataStore().userData.shippingInfo,
    'selectedShippingInfo':useUserDataStore().userData.selectedShippingInfo,
    'cart': useUserDataStore().userData.cart,
    'wishes': useUserDataStore().userData.wishes,
    'userInfo': {
      anon: useCurrentUser().value.isAnonymous,
      stripeCustomerId: useUserDataStore().userData.userInfo.stripeCustomerId,
      displayName: useUserDataStore().userData.userInfo.displayName===null ? useUserDataStore().userData.selectedShippingInfo.firstName + " " + useUserDataStore().userData.selectedShippingInfo.lastName : useUserDataStore().userData.userInfo.displayName,
      email: useCurrentUser().value.email,
      phone: useUserDataStore().userData.userInfo.phone ? useUserDataStore().userData.userInfo.phoneNumber : useCurrentUser().value.phoneNumber,
      uid: useCurrentUser().value.uid,
      verified: useCurrentUser().value.emailVerified
    }
  }, {merge:true}).then(()=>infoSubmitted.value = true)
  // infoSubmitted.value = true
  //End loader here
  showLoader.value = false

  // paymentElement.value = elements.create('payment')
  // paymentElement.value.mount('#payment-element') //paymentElementRef.value
  // const linkAuthenticationElement = elements.create("linkAuthentication")
  // linkAuthenticationElement.mount("#link-authentication-element")
}

const cancelIntent = async () => {
  await $fetch('/api/payment/stripe/cancel', {method:'POST',body:{orderId:firebaseOrderId.value}, headers:{token:await useCurrentUser().value.getIdToken()}})
  //remove the order from the user's view without messing with our backend data :P
  useUserDataStore().userData.orders = filter(useUserDataStore().userData.orders, (order)=>{return order.id!=firebaseOrderId.value})
  await navigateTo('/')
}

const submitButton = async () => {
  //Start loader here
  showLoader.value = true

  let originalWishes = JSON.stringify(useUserDataStore().userData.wishes)
  //If the user was wishing for this item, remove it from wishlist
  for(let i=0;i<useUserDataStore().userData.cart.length;i++){
    useUserDataStore().userData.wishes = filter(useUserDataStore().userData.wishes,(w)=>{return useUserDataStore().userData.cart[i].productId!=w.id})
  }
  //hold onto the original cart...
  let originalCart = JSON.stringify(useUserDataStore().userData.cart)
  useUserDataStore().userData.cart = []
  
  if(isLoading.value){
    return
  }
  isLoading.value = true
  const { error } = await stripe.confirmPayment({
    elements,
    confirmParams:{
      return_url: `${window.location.origin}/shop/orders/${firebaseOrderId.value}`
    }
  })

  if(error.type === "card_error" || error.type === "validation_error"){
    //display a popup with the message
    //clear the form!!!
    popupVisible.value = true
    popupMsg.value = error.message 
    // paymentElement.value.clear()
  }else{
    popupVisible.value = true
    popupMsg.value = "An unexpected  error occurred."
    console.log(error)
  }


  //Anything from here on will only run if the transaction did NOT succeed
  
  useUserDataStore().userData.cart = JSON.parse(originalCart)
  useUserDataStore().userData.wishes = JSON.parse(originalWishes)
  //update order doc, push error info to status log and stuff :D
  await $fetch('/api/orderStatusUpdate', {method: 'POST', body:{orderId:firebaseOrderId.value, token:await useCurrentUser().value.getIdToken(), msg:'Payment Error: ' + error.message}})

  isLoading.value = false
}

const submitNewAccount = async() => {
  //make the email account, just like the old way, just use ash's new form
  const v = await isValid.value.validate()
  console.log("isValid.validate().valid: " + v.valid)
  console.log(v.valid)
  if(v.valid){
    const newuser = await createUserWithEmailAndPassword(getAuth(useFirebaseApp()),newEmail.value,newPassword.value)
    //update displayName and phoneNumber if they were input?
    updateProfile(newuser.user,{firstName: newFirstName.value, lastName: newLastName.value, displayName:newDisplayName.value,phoneNumber:phoneNumber.value})

    // useCurrentUser().value = newuser.user //do i need to do this?  or like getAuth.curruser=newuser.user?
    const newDoc = useUserDataStore().userData //because of this, we should be pulling all the existing billingInfo, shippingInfo, cart and wish data
    newDoc.userInfo.email = newuser.user.email
    newDoc.userInfo.uid = newuser.user.uid
    newDoc.userInfo.displayName = newuser.user.displayName
    newDoc.userInfo.anon = false
    newDoc.userInfo.verified = newuser.user.emailVerified
    // newDoc.userInfo.bId = null
    newDoc.userInfo.stripeCustomerId = await $fetch('/api/payment/stripe/customer',{method:'POST',headers:{token:(await useCurrentUser().value.getIdToken())}})
    // newDoc.userInfo.idToken = user.user.getIdToken() //Not sure if this is necessary, or even a good idea

    useUserDataStore().userData = newDoc
    await setDoc(doc(useFirestore(),'users',newuser.user.uid),newDoc)
    //create new user doc in collection , and set defaults
    //could be cool to preset some of the user's shipping info using location data, right?
    //need a clone of this stuff in loginWithGoogle

    //I don't know if this is working - but it logs a msg in firebase emulators terminal :D
    sendEmailVerification(newuser.user) //We should potentially be setting an actionCodeURL here in order to complete the validation process... I think
    newAccountPopup.value = false
    await navigateTo('/checkout')
  }
}

</script>

<style scoped>

.butter {
  font-family: 'Pacifico';
  /* font-weight: 1000; */
  font-size: 3em;
  color: oklch(var(--nc));

  text-shadow: 
      -1px -1px 0 oklch(var(--bc)),  
      -1px -1px 0 oklch(var(--bc)),  
      1px -1px 0 oklch(var(--bc)),
      1px -1px 0 oklch(var(--bc)),
      -1px 1px 0 oklch(var(--bc)),
      -1px 1px 0 oklch(var(--bc)),
      1px 1px 0 oklch(var(--bc)),
      1px 1px 0 oklch(var(--bc)),

    2px 2px 0px oklch(var(--bc)),
    3px 3px 0px oklch(var(--bc)), 
    4px 4px 0px oklch(var(--bc)), 
    5px 5px 0px  oklch(var(--bc)), 
    6px 6px 0px oklch(var(--bc)), 
    7px 7px 0px oklch(var(--bc));

}
.btnstyle_findsomething {
  background-color: rgb(var(--v-theme-primary-darken-3));
  background-image: linear-gradient(to bottom, rgb(var(--v-theme-primary-darken-2)), 5%, rgb(var(--v-theme-primary)), 80%, rgb(var(--v-theme-primary-darken-3)));
  border: 0;
  border-radius: .25rem;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  font-family: ui-sans-serif,system-ui,-apple-system,system-ui,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
  font-size: 1.125rem; /* 18px */
  font-weight: 600;
  line-height: 1.75rem; /* 28px */
  padding: 1rem 1.25rem;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

.btnstyle_findsomething:hover {
  box-shadow: none;
}

@media (min-width: 1024px) {
  .btnstyle_findsomething {
    font-size: 1.5rem; /* 24px */
    padding: 1rem 1.5rem;
    line-height: 2rem; /* 32px */
  }
}
.btnstyle_outlinetofilled{
  transition: .2s ease-in-out 0s;
  color: rgb(var(--v-theme-primary-darken-3));
  border: 3px solid rgb(var(--v-theme-primary-darken-2));
}

.btnstyle_outlinetofilled:hover{
  background-color: rgb(var(--v-theme-primary-darken-3));
  border: 3px solid rgb(var(--v-theme-primary-darken-3));
  color: #fff;
}

.btnstyle_outlinetofilled:disabled{
  background-color: rgb(var(--v-theme-surface-darken-3));
  border: 3px solid rgb(var(--v-theme-surface-darken-3));
  color: #fff;
}

</style>